import {
  Breadcrumbs as MantineBreadcrumbs,
  BreadcrumbsProps,
} from '@mantine/core';

export type IBreadcrumbsProps = BreadcrumbsProps;

/** @registry Design-layer pass-through over Mantine Breadcrumbs; import this instead of @mantine/core Breadcrumbs outside src/design. */
export const Breadcrumbs = MantineBreadcrumbs;
